import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsuranceCarrier = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "insuranceCarrier",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16866",
		"data-name": "Group 16866",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12489",
				"data-name": "Path 12489",
				d: "M4,18V9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12490",
				"data-name": "Path 12490",
				d: "M20,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12491",
				"data-name": "Path 12491",
				d: "M8,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12492",
				"data-name": "Path 12492",
				d: "M12,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12493",
				"data-name": "Path 12493",
				d: "M16,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12494",
				"data-name": "Path 12494",
				d: "M12,6.275a.124.124,0,0,0-.124.125.125.125,0,0,0,.25,0A.127.127,0,0,0,12,6.275",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12495",
				"data-name": "Path 12495",
				d: "M21.5,9H2.5V6.361L12,3l9.5,3.361Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12496",
				"data-name": "Path 12496",
				d: "M21,18H3L2,19v2H22V19Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12497",
		"data-name": "Path 12497",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgInsuranceCarrier;
